const baguetteBox = require('baguettebox.js');

window.addEventListener('DOMContentLoaded', () => {
  baguetteBox.run('.gallery');
});
